// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__tL1vQ","lastLink":"HeadPage_lastLink__HZe5W"};